import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import { IntroText, CheckboxList, FormActionDrawer } from "../../../components";
import { useHeader } from "../../../contexts";
import {
  formatApiValuesFromCheckboxList,
  formatCheckboxListFromApiValues
} from "../../../utils";
import { useTranslation } from "react-i18next";

const OptionsData = [
  {
    value: "heart_disease",
    label_translation_key:
      "schedule.pre_existing_conditions.options.heart_disease"
  },
  {
    value: "diabetes",
    label_translation_key: "schedule.pre_existing_conditions.options.diabetes"
  },
  {
    value: "respiratory_disease",
    label_translation_key:
      "schedule.pre_existing_conditions.options.respiratory_disease"
  },
  {
    value: "autoimmune_disease",
    label_translation_key:
      "schedule.pre_existing_conditions.options.autoimmune_disease"
  },
  {
    value: "other_chronic_disease",
    label_translation_key:
      "schedule.pre_existing_conditions.options.other_chronic_disease"
  },
  {
    value: "allergies",
    label_translation_key: "schedule.pre_existing_conditions.options.allergies"
  }
];

const SchedulePreExistingConditions = ({
  setDrawerClearance,
  updateScheduleData,
  scheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const [preExistingConditions, setPreExistingConditions] = useState();

  useEffect(() => {
    setTitle(t("schedule.pre_existing_conditions.title"));
  }, []);

  const handleNext = () => {
    updateScheduleData({
      preExistingConditions: formatApiValuesFromCheckboxList(
        OptionsData,
        preExistingConditions
      )
    });
  };

  return (
    <Box data-cy="schedule-screen-pre-existing-conditions">
      <IntroText>{t("schedule.pre_existing_conditions.intro_text")}</IntroText>
      {OptionsData.length > 0 && (
        <CheckboxList
          allowMultiple
          options={OptionsData}
          onChange={setPreExistingConditions}
          initialValues={formatCheckboxListFromApiValues(
            scheduleData.preExistingConditions
          )}
        />
      )}
      <FormActionDrawer
        setDrawerClearance={setDrawerClearance}
        handleNext={e => handleNext()}
        loading={isSubmitting}
      />
    </Box>
  );
};

export { SchedulePreExistingConditions };
